import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import OpportunityListUpdatedModalContainer from "app/pages/sales-intelligence/common-components/OpportunityListUpdatedModal/OpportunityListUpdatedModalContainer";
import useClearSelectionAndClosePanel from "app/pages/sales-intelligence/hooks/useClearSelectionAndClosePanel";
import SaveToListButtonBaseContainer from "app/pages/sales-intelligence/sub-modules/opportunities/containers/SaveToListButton/SaveToListButtonBaseContainer";
import type { TableActionProps } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/TableActionsPanel/types";

import SaveToListTooltipContent from "../../../../opportunities/components/table-actions-panel/SaveToListTooltipContent/SaveToListTooltipContent";
import { COMPETITIVE_LANDSCAPE_TABLE_KEY, COMPETITIVE_LANDSCAPE_TABLE_PROPERTY } from "../../configuration/constants";

import SaveToListCompetitivePanelContainer from "./SaveToListCompetitivePanelContainer";

const TooltipContent = (props: { isOutOfQuota: boolean }): ReactElement => {
    return (
        <SaveToListTooltipContent
            isOutOfQuota={props.isOutOfQuota}
            i18nKeyModifier="account"
        />
    );
};

const SaveToListCompetitiveButtonContainer = (props: TableActionProps): ReactElement => {
    const clearSelectionAndClosePanel = useClearSelectionAndClosePanel(
        COMPETITIVE_LANDSCAPE_TABLE_KEY,
        COMPETITIVE_LANDSCAPE_TABLE_PROPERTY,
    );

    return (
        <>
            <OpportunityListUpdatedModalContainer
                title={translate("si.opportunity-list-updated-modal.title")}
                onClose={clearSelectionAndClosePanel}
            />
            <SaveToListButtonBaseContainer
                isDisabled={props.isDisabled}
                renderTooltipContent={TooltipContent}
                onClick={() => props.onActivate(() => SaveToListCompetitivePanelContainer)}
            />
        </>
    );
};

export default SaveToListCompetitiveButtonContainer;
